export default "__VITE_ASSET__jZQ7g56m__"